import Index from '../views/Regulacao/Index'
import Detail from '../views/Regulacao/Detail'

let routes = {
    path: '/regulacao',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/regulacao',
            name: 'regulacao',
            component: Index,
            meta: {
                pageTitle: 'regulacao.title',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'regulacao.title',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/regulacao/:id',
            name: 'regulacao-detail',
            component: Detail,
            meta: {
                pageTitle: 'regulacao.title',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'regulacao.title',
                        to: '/regulacao',
                    },
                    {
                        text: 'regulacao.breadcrumbDetail',
                        active: true,
                    },
                ],
            },
        },
    ],
}

export default routes
